/**
 * @file link.component.tsx
 * @description Пункт бокового меню, который представляет собой кликабельную ссылку с поддержкой активных состояний и навигации
 * @author AI-Generated | Human-Reviewed
 * @created 2025-09-03
 * @updated 2025-09-10
 * @dependencies ['react', 'react-router-dom', 'classnames']
 * @related-files []
 */

import cn from 'classnames';
import { MouseEventHandler } from 'react';
import { NavLink } from 'react-router-dom';

/**
 * Props для компонента ссылки бокового меню
 */
interface ILinkProps {
    /** Флаг активного состояния ссылки */
    isActive: boolean;
    /** Флаг родительской ссылки (внешняя ссылка) */
    isParent?: boolean;
    /** Флаг заблокированного состояния ссылки */
    isDisabled?: boolean;
    /** Цель открытия ссылки */
    target: '_self' | '_blank';
    /** Относительная навигация (тип определяется контекстом) */
    relative?: unknown;
    /** Название иконки для ссылки */
    iconName?: string;
    /** Обработчик клика по ссылке */
    onClick?: MouseEventHandler<HTMLAnchorElement>;
    /** URL адрес для навигации */
    to?: string;
    /** Текст заголовка ссылки */
    title: string;
}

export const Link = ({
    isActive = false,
    target = '_self',
    onClick,
    to,
    title,
    isParent = false,
    isDisabled = false,
    ...props
}: ILinkProps) =>
    isParent ? (
        <a
            className={cn('py-[0.833vmin] px-[2.5405vmin] circle-before', {
                'nav-active': isActive,
                'nav-disabled': isDisabled
            })}
            target={target}
            onClick={onClick}
            href={to}
            rel="noopener noreferrer"
            {...props}
        >
            {title}
        </a>
    ) : (
        <NavLink
            className={cn('py-[0.833vmin] px-[2.5405vmin] circle-before', {
                'nav-active': isActive,
                'nav-disabled': isDisabled
            })}
            target={target}
            onClick={onClick}
            to={to || '*'}
            rel="noopener noreferrer"
        >
            {title}
        </NavLink>
    );
